export const DEV_SETTINGS_KEY = 'devSettings';
export const REDUX_LOGGING_KEY = 'reduxLogging';
export const LOG_LEVEL_KEY = 'logLevel';
